/**
 * @module
 *
 * @import {Engine} from '@acng/frontend-stargazer';
 * @import {LivecamSession} from 'acng/livecam/model/session.js';
 * @import {authUser} from './env';
 */

import {digest, errorTemplate, rootScope} from '@acng/frontend-stargazer';
import {GlobalWatchGroup} from '@acng/frontend-relativity';
import {body, createDiv, removeChildNodes, setHtml} from '@acng/frontend-bounty';
import {ctxAuthUser} from 'acng/userPool/context/auth-user.js';
import {ctxLocale} from 'acng/locale/model/locale.js';
import {throttle} from '@acng/frontend-bounty/timing/throttle.js';
import {hookFeature} from '../config/feature.js';
import {connectLocation, disconnectLocation} from './location.js';
import {createFrontendFeature} from '../model/feature.js';
import {ctxLivecamSession} from '../../livecam/context/session.js';
import {app} from '../../app.js';
import {assign} from '@acng/frontend-bounty/object.js';

setHtml(errorTemplate, '<strong class="drf-notfound">🚧 ${message} 🚧</strong>');

createFrontendFeature('lv6');

/**
 * @param {angular.IRootScopeService} $rootScope
 * @param {angular.ICompileService} $compile
 */
export const runBootstrap = ($rootScope, $compile) => {
  /**
   * @type {angular.IScope}
   */
  let $scope;

  /**
   * @type {Engine}
   */
  let engine;

  let eventDuringLivecamSession = false;

  /**
   * @param {[LivecamSession | null, unknown, unknown]} values
   * @param {[LivecamSession | null | undefined, unknown, unknown]} previous
   */
  const bootstrap = async ([livecamSession], [prevLivecamSession]) => {
    if (livecamSession != prevLivecamSession) {
      if (livecamSession || !eventDuringLivecamSession) {
        return;
      }

      eventDuringLivecamSession = false;
    } else if (livecamSession) {
      if (!prevLivecamSession) {
        eventDuringLivecamSession = true;
      }

      return;
    }

    removeChildNodes(div);
    engine?.disconnect();
    $scope?.$destroy();
    assign(rootScope, app);
    disconnectLocation();
    digest();
    $scope = $rootScope.$new();
    engine = await hookFeature.render('body');
    DEBUG: console.warn('BOOTSTRAP', engine);
    $compile(engine.toElement(div))($scope);
    connectLocation();
    $scope.$digest();
  };

  const div = createDiv();
  body.prepend(div);

  GlobalWatchGroup(ctxLivecamSession, ctxAuthUser, ctxLocale)(throttle(bootstrap, 10, false));
};
